import "./patientview.css";

import {
  Dashboard,
  TableAndOverlapAndTreeDashboard,
  TableAndOverlapDashboard,
  TableOnlyDashboard,
} from "./SurveyModeDashboards";

import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { useSelector } from "react-redux";
import { useSurveyMode } from "../../contexts/SurveyModeProvider";
import { useLocation } from "react-router-dom";

const PatientDashboard = ({ micro_id }) => {
  const location = useLocation();
  const { survey } = useSelector((state) => state);
  const { debug_mode } = useSurveyMode();
  const activeCase = useSelector((state) => state.survey.activeCase);
  
  const patientExists = Boolean(survey.patients[micro_id]);

  const surveyHistoryForThisMicro = survey.surveyHistory[micro_id];
  const debugSurveyMode = survey.debug_survey_mode;

  // Check if we are on the active case
  const isOnActiveCase =
    activeCase && location.pathname === `/patient/${activeCase.micro_id}`;

  // Helper: returns the correct Dashboard component based on a "mode"
  const renderDashboardForMode = (theMode) => {
    if (!theMode) {
      // If no mode is found, default to TableOnly or your choice
      return <TableOnlyDashboard micro_id={micro_id} />;
    }

    switch (theMode) {
      case 1:
        return <TableOnlyDashboard micro_id={micro_id} />;
      case 2:
        return <TableAndOverlapDashboard micro_id={micro_id} />;
      case 3:
        return <TableAndOverlapAndTreeDashboard micro_id={micro_id} />;
      default:
        return <Dashboard micro_id={micro_id} />;
    }
  };

  const renderDashboard = () => {
    // 1) If in debug mode
    if (debug_mode) {
      if (debugSurveyMode === 1) {
        return <TableOnlyDashboard micro_id={micro_id} />;
      } else if (debugSurveyMode === 2) {
        return <TableAndOverlapDashboard micro_id={micro_id} />;
      }
      return <Dashboard micro_id={micro_id} />;
    }

    // 2) If in survey mode AND isOnActiveCase => use this micro_id's mode
    if (isOnActiveCase) {
      console.log("Active case for this micro_id:", micro_id);
      const modeForThisMicro = surveyHistoryForThisMicro?.mode;
      return renderDashboardForMode(modeForThisMicro);
    }

    // 3) Otherwise => not the active case. 
    //    => Use the activeCase's mode but apply it to this micro_id
    console.log("Not on active case, but referencing activeCase mode");
    const modeFromActiveCase =
      survey.surveyHistory[activeCase?.micro_id]?.mode || 0;
    return renderDashboardForMode(modeFromActiveCase);
  };

  return patientExists ? renderDashboard() : <Spinner animation="border" />;
};
export default PatientDashboard;